// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__1qeGI","actionsCol":"EnrolledClinics_actionsCol__32O8Y"};